module.exports = __webpack_public_path__ + "img/5valvulas.63925480.jpg";